import { uuid } from '@utils/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

export const getMaxKpiSelectionOptions = (maxValue: number): TSelectOption[] => {
	if (maxValue === 0) return [];

	const resultArray = [];

	for (let i = 1; i <= maxValue; i++) {
		resultArray.push({
			id: uuid(),
			value: i,
			label: `${i}`,
		});
	}

	return resultArray;
};
